import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';

const PageContainer = ({ classes, children }) => (
  <div className={classes.root}>
    <div className={classes.wrapper}>
      {children}
    </div>
  </div>
);

PageContainer.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.any.isRequired,
};

const styles = theme => ({
  root: {
    flex: '1 0 0',
    flexDirection: 'row',
    padding: '0 0.6rem',
    minWidth: '20rem',
    marginLeft: theme.containerMarginBase(),
  },
  wrapper: {
    maxWidth: '68.5rem',
    margin: 'auto',
  },
});

export default withStyles(styles)(PageContainer);
